import type { AppIconProps } from '../Icons.types';
import { getClassNames } from '../Icons.utils';
import styles from './Locked.module.scss';

export const AppLockedIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      className={classNames}
    >
      <path
        d="M8.21284 4.72402V3.65052C8.21284 2.39402 7.19384 1.37502 5.93734 1.37502C4.68084 1.36952 3.65784 2.38352 3.65234 3.64052V3.65052V4.72402"
        stroke="#3445AB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8415 10.625H4.021C2.974 10.625 2.125 9.77648 2.125 8.72898V6.58448C2.125 5.53698 2.974 4.68848 4.021 4.68848H7.8415C8.8885 4.68848 9.7375 5.53698 9.7375 6.58448V8.72898C9.7375 9.77648 8.8885 10.625 7.8415 10.625Z"
        stroke="#3445AB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.93164 7.10156V8.21206"
        stroke="#3445AB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
